'use strict';

/* global $ */

let settings = {
    selector: '.js-nicescroll'
};

class NiceScroll {
	constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ NiceScroll/init ]');

        let $block = $(this.opt.selector),
        	$railSelector = $(this.opt.railSelector);

        $block.niceScroll({
            autohidemode: false,
            background: 'rgba(0, 51, 153, 0.4)',
            border: '1px solid rgba(0, 51, 153, 1)',
            cursorcolor: 'rgba(0, 51, 153, 1)',
            cursorborder: '1px solid rgba(0, 51, 153, 1)',
            cursorwidth: '5px'
        });

        $('#ascrail2000').css({
            'border-radius': '5px',
            'width': '5px'
        });
        $('#ascrail2001').css({
            'border-radius': '5px',
            'width': '5px'
        });

        $(window).on('resize', (e) => {
            $block.getNiceScroll().resize();
        });
    }
}


export {
	NiceScroll
};